import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { renderPerformanceBar } from 'legacy-src/components/assessment/Results/utility';
import A11y from 'chameleon/ui-stack/utilities/a11y';
import ScoredIcon from 'chameleon/ui-stack/ui/assessments/scored-icon';

const StudentSingleAssignmentProgress = (props) => {
  const { assignment, location, params } = props;
  const { pathname, search } = location;
  const { subject } = params;
  const { id: assignmentId, score, maxScore, sessionStatus } = assignment || {};
  const returnPath = `${pathname}${search}`;

  const studentScore = {
    learnosityReportMaxScore: maxScore,
    learnosityReportScoreParsed: score,
  };

  const to = {
    pathname: `/${subject}/assessments/results/${assignmentId}`,
    state: { returnPath },
  };

  return (
    <Fragment>
      {!!maxScore && (
        <div className="flex items-center">
          <A11y>
            {renderPerformanceBar({
              studentScore,
              linkProps: { to, onlyActiveOnIndex: false },
            })}
          </A11y>
          <StudentScoreIcon studentSubmission={{ status: sessionStatus }} />
        </div>
      )}
    </Fragment>
  );
};

StudentSingleAssignmentProgress.propTypes = {
  assignment: PropTypes.object.isRequired,
};

const StudentScoreIcon = ({ studentSubmission }) => {
  return (
    <ScoredIcon
      teacherAndStudentScored={
        studentSubmission.status === 'teacher_and_student_scored' ? 1 : 0
      }
      studentScored={studentSubmission.status === 'student_scored' ? 1 : 0}
      teacherScored={studentSubmission.status === 'scored' ? 1 : 0}
    />
  );
};

export default withRouter(StudentSingleAssignmentProgress);
